<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="SalesForecastInputDetail"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">Detail Sales Forecast</h6>
                  
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseExample" 
                    aria-expanded="false" 
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                      <p class="text-muted">{{this.forms.create_by}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{this.forms.created_at}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{this.forms.update_by}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{this.forms.updated_at}}</p>
                    </div>

                    
                    
                  </div>

                </div>
                <span v-if="forms.status == 'APPROVED' || forms.status == 'REJECTED'">
                  <div class="card-header">
                      &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left:25px">Status : {{forms.status}}</h6>
                    </div>
                  </span>

                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    ></div>

                    <div class="card">
                      <div class="card-body">
                        <h5 class="General"></h5>
                        <hr>
                        
                     

                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("forecastPeriodYearTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <input
                              type="text"
                              class="form-control"
                              id="forecast_year"
                              :placeholder="$t('forecastPeriodYearTxt')"
                              v-model="forms.forecast_year"
                              disabled
                            />
                            <div v-if="errors.forecast_year">
                              <div
                                v-for="error in errors.forecast_year"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("forecastPeriodMonthTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-4">
                            <input
                              type="text"
                              class="form-control"
                              id="forecast_month_name"
                              :placeholder="$t('forecastPeriodMonthTxt')"
                              v-model="forms.forecast_month_name"
                              disabled
                            />
                            <div v-if="errors.forecast_month_name">
                              <div
                                v-for="error in errors.forecast_month_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <span v-if="forms.status == 'APPROVED' || forms.status == 'REJECTED'">
                     
                        <div  class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Approval Name</label>
                          </div>
                          <div class="col-lg-3">
                            <input
                              type="text"
                              class="form-control"
                              id="forecast_year"
                              :placeholder="$t('forecastPeriodYearTxt')"
                              v-model="forms.approval_name"
                              disabled
                            />
                            <div v-if="errors.forecast_year">
                              <div
                                v-for="error in errors.forecast_year"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label">Approval Comments</label>
                          </div>
                          <div class="col-lg-4">
                            <input
                              type="text"
                              class="form-control"
                              id="forecast_month_name"
                              :placeholder="$t('forecastPeriodMonthTxt')"
                              v-model="forms.approval_comments"
                              disabled
                            />
                            <div v-if="errors.forecast_month_name">
                              <div
                                v-for="error in errors.forecast_month_name"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </span>

                      <span v-if="forms.have_child == 'Yes' && forms.status == 'REJECTED'">
                      <button
                    class="btn btn-info"
                    type="button"
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseExamplea" 
                    aria-expanded="false" 
                    aria-controls="collapseExamplea"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Member
                  </button>

                  <div class="row mb-3 collapse" id="collapseExamplea" style="padding-left:20px">
                    <div class="table-responsive">
                          <table
                            class="table table-hover"
                            style="height: 300px"
                          >
                            <thead>
                              <tr>
                                <th>#</th>
                                <th width="300px">Sales</th>
                                <th width="200px">Action</th>
                                
                             
                               
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(input, index) in this.formsdetailChild"
                                :key="`phoneInput-${index}`"
                              >
                                <th>{{ index + 1 }}</th>
                                <td width="200px">
                                 {{input.master_sales.sales_name}}
                                </td>
                                <td> <a
                              href="#"
                              v-if="permision_role.method_read"
                              title="Detail"
                              @click.prevent="
                                openModal(input)
                              "
                            >
                              <i class="mdi mdi-eye" style="font-size:16px"></i>
                              
                            </a></td>
                                

                                
                             
                              </tr>
                            </tbody>

                            <tfoot></tfoot>
                          </table>
                        </div>
                    
                    
                  </div>
                </span>
                      
                    </div>
                  </div>
                       


                    <br />

                  <div class="row card">
                    
                    <div class="card-header">
                      <h5>Detail</h5>
                    <button
                    v-if="permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                    >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                    </button>

                    </div>

                    <div class="card-body">
                      <div  class="table-responsive table-striped" style="max-height:500px">
                        <table  class="table table-hover table-bordered table-xs">
                        

                          <thead style="position: sticky;top: 0;background-color:#ab0635;color: white;  text-align: center;"  >
                            <tr style="color: white;">
                              <th>#</th>
                              <th style="color: white;" width="300px">Business Unit</th>
                              <th style="color: white;" width="300px">Area</th>
                             <th style="color: white;" width="300px">Customer Code</th>
                           
                              <th style="color: white;" width="300px">Customer Name</th>
                     
                              <th style="color: white;"  v-for="(column, index) in formsdetails_bulan" :key="index"> {{column}}</th>
                             
                       
                            </tr>
                          </thead>

                          <tbody>
                            

                            <tr v-for="(item, indexs) in formsdetails" :key="`phoneInput-${indexs}`"  >
                              <th>{{ parseInt(indexs)+1 }}</th>
                              <td>{{ item.bu_name }}</td>
                              <td>{{ item.area_name }}</td>
                              <td>{{ item.customer_code }}</td>
                              <td>{{ item.customer_name }}</td>

                          <td style="text-align: right;" v-for="(column, indexColumn) in formsdetails_bulan" :key="indexColumn">
                           {{formatNumber(item[column])}}</td>
                          </tr>
                          
                          </tbody>

                          <tfoot style="font-weight:bold;text-align: right;">
                            <tr>
                            <td style="text-align: center" colspan="5">TOTAL</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[0]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[1]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[2]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[3]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[4]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[5]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[6]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[7]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[8]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[9]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[10]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[11]))}}</td>

                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[12]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[13]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[14]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[15]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[16]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[17]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[18]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[19]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[20]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[21]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[22]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[23]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[24]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[25]))}}</td>
                            <td>{{formatNumber(SumTotal(formsdetails,formsdetails_bulan[26]))}}</td>
                          
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>

                  

                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="permision_role.method_update && (forms.status == 'REJECTED' || forms.status == 'DRAFT')" 
                        class="
                          btn btn-info
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="submitData()"
                      >
                        <i class="link-icon" data-feather="check-square"></i>
                       
                        {{ $t("submitMess") }}
                      </a>

                      <a
                        v-if="permision_role.method_update && (forms.status == 'REJECTED' || forms.status == 'DRAFT')"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="editData()"
                      >
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->
        <modal-approval :showModal="showmodalDetailMemberApproval" :data="this.dataModal" @closeModal="closeMyModal">
        </modal-approval>
        <modal-member :showModal="showmodalDetailMember" :data="this.dataModalMember" @closeModal="closeMyModalMember">
        </modal-member>
        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import modalDetailMemberApproval from "@/components/modal/modalDetailMemberApproval.vue";
import modalDetailMember from "@/components/modal/modalDetailOutstandingMember.vue";



export default {
  name: "SalesApprovalDetail",
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "modal-approval": modalDetailMemberApproval,
    "modal-member": modalDetailMember,
    
  },
  data() {
    return {
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchCompany:[],
      fetchRegion:[],
      userData: "",
      companyCode: "",
      forms: [],
      detailAll: [],
      fetchSales:[],
      showmodalDetailMemberApproval: false,
      showmodalDetailMember: false,
      sales_approval_detail:[],
      center: { 
        lat: 39.7837304,
        lng: -100.4458825
      },
      locationMarkers: [],
      locPlaces: [],
      existingPlace: null,
      formsdetails:[],
      formsdetailChild:[],
      formsdetails_bulan:[],
      dataModal: {},
      dataModalMember: {},
      // columns: [
      //   {
      //     label: "Sales Name",
      //     field: "master_sales.sales_name",
      //     filterOptions: {
      //       enabled: true, // enable filter for this column
      //       placeholder: "Filter By Sales", // placeholder for filter input
      //       filterValue: "", // initial populated value for this filter
      //       filterDropdownItems: [], // dropdown (with selected values) instead of text input
      //       trigger: "enter", //only trigger on enter not on keyup
      //     },
      //   },
        

       

      //   {
      //     label: "Action",
      //     field: "actions",
      //     sortable: false,
      //   },
      // ],
    };
  },

  
  watch: {},
  methods: {
    resetForm() {

    },

    cek_message(status,msg){
      if(status=='200'){
        this.success(msg);
      }
    },
    formatNumber(value){
      return parseInt(value).toLocaleString()
    },


    editData(){
      var params = this.$route.params.id
      window.location.href = "/input-forecast/edit/"+ params;
    },

    loadSales() {
      const baseURI = this.$settings.endPoint + "sales";
      return this.$http.get(baseURI).then((response) => {
        this.fetchSales = response.data.datas.data;
      });
    },

    SumTotal(data,bulan){
      var count = Object.keys( data).length;
       
       var total=0;
     for (var x = 0; x < count; x++) {
      
       var nameOb = Object.keys(data)[x];
     
       var objectData = data[nameOb];
     
       total +=  parseInt(objectData[bulan])
      
     }
      return total;
    },

    asyncSearchSales(ev) {
      const baseURI = this.$settings.endPoint + "sales?status=Active&sales_name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchSales = response.data.datas.data;
      });
    },

    downloadData() {
      const baseURI = this.$settings.endPoint + "/sales-forecast/download-view-forecast/" + this.sales_forecast_header_id;

      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
          baseURI ,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    deleteData() {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPoint + "sales-approval/delete/" + id;
          this.$http
            .delete(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/sales_approval";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.error(error.response.data.errors.message);
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    submitData() {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourForecastSubmit"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            forecast_year:this.forms.forecast_year,
            forecast_month:this.forms.forecast_month,
            forecast_month_name:this.forms.forecast_month_name
          };
          const baseURI =
            this.$settings.endPoint + "sales-forecast/submit-forecast/" + id;
          this.$http
            .put(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/input-forecast";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.error(error.response.data.errors.message);
                } else if (error.response.status === 420) {
                  this.errors =error.response.data.errors.messages;
                  this.showmodalDetailMember = true;
                    this.dataModalMember = {
                    
                    forecast_year : this.forms.forecast_year,
                    forecast_month : this.forms.forecast_month,
                    period_forecast : this.forms.forecast_month_name +" " +this.forms.forecast_year,
                    error_kata : this.errors.toString(),
                   
                    }
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    openModal(row) {
    
     
    this.showmodalDetailMemberApproval = true;
    this.dataModal = {
      sales_forecast_approval_id : row.sales_forecast_approval_id,
      sales_forecast_header_id: row.sales_forecast_header_id,
     period_forecast :row.forecast_month_name +" " + row.forecast_year,
     period_year : row.forecast_year,
     period_month : row.forecast_month,
      sales_name : row.master_sales.sales_name,
      approval_status : row.approval_status,
      status : row.status
    }

  },

  closeMyModal() {
    this.loadDataDetailChild( this.forms.sales_forecast_approval_id);

    this.showmodalDetailMemberApproval = false;
  },

  openModalMember() {
    
     
    this.showmodalDetailMember = true;
    this.dataModalMember = {
     
     forecast_year : this.forms.forecast_year,
     forecast_month : this.forms.forecast_month,
    
    }

  },

  closeMyModalMember() {
    

    this.showmodalDetailMember = false;
  },

    initMarker(loc) {
      this.existingPlace = loc;
    },

    backForm() {
      window.location.href = "/input-forecast";
    },


    loadCompany() {
      const baseURI = this.$settings.endPoint + "company?limit=100";
     
      return this.$http
        .get(
          baseURI
        )
        .then((response) => {
            this.fetchCompany=response.data.datas.data;
        });
    },





    loadData(id) {
      this.detailAll=[];
      const baseURI = this.$settings.endPoint + "sales-forecast/detail/" + id;
      return this.$http.get(baseURI).then((response) => {
        
        this.forms = response.data.datas;
       
        // this.bu_name = this.forms.master_bu.bu_name;
        this.sales_forecast_header_id= this.forms.sales_forecast_header_id;
       
        

        this.loadDataDetail(id);
        this.loadDataDetailChild( this.forms.sales_forecast_approval_id);


        // this.forms.sales_approval_detail.forEach((item) => {
        //   const data={

        //     master_sales:{
                
        //           sales_id:item.sales_id,
        //           user_id:item.user_id,
        //           sales_name:item.sales_name,
        //           sales_email:item.sales_email,
        //           status:item.status,
                  
        //         },
        //         level:item.level, 
        //       }
          
        //   this.detailAll.push(data);
        // })
      
      
      });
    },

    loadDataDetail(id) {
      this.detailAll=[];
      const baseURI = this.$settings.endPoint + "sales-forecast/detail-view-forecast/" + id;
      return this.$http.get(baseURI).then((response) => {
        
        this.formsdetails = response.data.datas.data;
        this.formsdetails_bulan = response.data.datas.bulan;

    
      
      
      });
    },

    loadDataDetailChild(id) {
      this.detailAll=[];
      const baseURI = this.$settings.endPoint + "sales-forecast/detail-child/" + id;
      return this.$http.get(baseURI).then((response) => {
        
        this.formsdetailChild = response.data.datas;
     
        // this.rows = response.data.datas.data;
        // this.totalRecords = response.data.datas.total;
    
      
      
      });
    },




    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'SalesForecastController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;

    },


    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.cek_message(this.$route.query.status,this.$route.query.msg);
   
    this.fetchIt();
 
  },
};
</script>
<style scoped>
</style>